import {
  ChannelOrder,
  ChannelOrderPayload,
  EditChannelOrderPayload,
} from "../../../types";
import { get, patch, post } from "../axiosConfig";

export const ChannelOrderApi = {
  async getChannelOrderList({
    search,
    limit,
  }: {
    search: string | null;
    limit?: number;
  }): Promise<{ count: number; items: ChannelOrder[] }> {
    const params: { search?: string; limit?: number } = {};
    if (!!search) {
      params.search = search;
    }
    if (!!limit) {
      params.limit = limit;
    }
    const { data } = await get("/telegram-fast-views/channel-orders", {
      params,
    });
    return data;
  },

  async addChannelOrder(formData: ChannelOrderPayload): Promise<ChannelOrder> {
    const { data } = await post(
      "/telegram-fast-views/channel-orders",
      formData
    );
    return data;
  },

  async cancelChannelOrder(payload: number[]): Promise<string> {
    const { data } = await post(
      "/telegram-fast-views/channel-orders/cancel",
      payload
    );
    return data;
  },

  async editChannelOrder({
    formData,
    id,
  }: {
    formData: EditChannelOrderPayload;
    id: number;
  }): Promise<ChannelOrder> {
    const { data } = await patch(
      `/telegram-fast-views/channel-orders/${id}`,
      formData
    );
    return data;
  },
};
